import { useTranslationInvestor } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { VestingExpandedContent } from '@dealstack/frontend/shared/components/VestingChart/VestingExpandedContent.tsx';
import { useShareholderSecurityVestingQuery } from '@dealstack/frontend/investor/pages/Valuations/InvestorHoldingsTable/hooks/useShareholderSecurityVestingQuery.ts';

interface Props {
	investorId: string;
	securityId: string;
	tInvestor: ReturnType<typeof useTranslationInvestor>;
}

export const InvestorVestingExpandedContent = ({ investorId, securityId, tInvestor }: Props) => {
	const vestingQuery = useShareholderSecurityVestingQuery(investorId, securityId, true);

	return (
		<VestingExpandedContent
			vestingQuery={vestingQuery}
			tFunction={tInvestor}
			tooltipTranslationKey="valuations.holding_table.chart.tooltip"
			xLabel={tInvestor('valuations.holding_table.chart.x_label')}
			yLabel={tInvestor('valuations.holding_table.chart.y_label')}
		/>
	);
};
